/**
 * angular-validation - v1.1 - 2014-05-02
 * https://github.com/ghiscoding/angular-validation
 * @author: Ghislain B.
 *
 * @desc: If a field becomes invalid, the text inside the error <span> or <div> will show up because the error string gets filled
 * Though when the field becomes valid then the error message becomes an empty string, 
 * it will be transparent to the user even though the <span> still exist but becomes invisible since the text is empty.
 *
 * Version 1.1: only start validating after user inactivity, 
 * it could also be passed as an argument for more customization of the inactivity timeout (typing-limit)
 */
 angular.module('ghiscoding.validation')
  .directive('validation2', function($translate, $timeout, $rootScope,showPageService) {
    return {
      require: "ngModel",
      link: function(scope, elm, attrs, ctrl) {
        var constants = {
          length : {
            name : "length",
            minLen : "minLength",
            maxLen : "maxLength"
          },
          required : {
            name : "required"
          },
          stakeHolder_required : {
            name : "stakeHolder_required"
          },
          stakeHolder_selectFromOptions : {
            name : "stakeHolder_selectFromOptions"
          },
          futureDate : {
            name : "futureDate" 
          },
          pastDate : {
            name : "pastDate" 
          },
          compareDate : {
            name : "compareDate"
          },
          numeric : {
            name : "numeric"
          },
          numericRange : {
            name : "numericRange",
            minNum : "minNumber",
            maxNum : "maxNumber"
          }
        }
          function getLabelForName(name) {
              return $("[name = '"+name+"']").closest("label").find(".fieldLabel span:eq(0)").text();
          }
          var bindFieldToBlockChars = function(allowDot, allowMinus, unbindPrevious) {
              if(!angular.isDefined(elm.prop('type'))){
                  return;
              }
              appendClassForNumberTypeField(elm);
              if(unbindPrevious){
                  elm.unbind('keydown');
              }
              elm.bind('keydown', function(e) {
                  var charCode = (e.which) ? e.which : ((typeof event !== "undefined") ? event.keyCode : undefined);
                  if(typeof charCode === "undefined") {
                      e.preventDefault();
                      return false;
                  }
                  var allowed_chars = [46,8, 9, 27, 13, 110];
                  if(allowDot){
                      allowed_chars.push(190);
                  }
                  if(allowMinus){
                      allowed_chars.push(189);
                  }
                  // Allow: backspace, delete, tab, escape, enter and .
                  if ($.inArray(e.keyCode, allowed_chars) !== -1 ||
                      // Allow: Ctrl+A, Ctrl+C, Ctrl+V,Ctrl+X
                      ([65,67,86,88].indexOf(charCode) > -1 && e.ctrlKey === true) ||
                      // Allow: home, end, left, right
                      (charCode >= 35 && charCode <= 39)) {
                      // let it happen, don't do anything
                      return true;
                  }
                  if ((e.shiftKey || (charCode < 48 || charCode > 57)) && (charCode < 96 || charCode > 105)) {
                      e.preventDefault();
                      return false;
                  }
              });
          }



        // constant of default typing limit in ms
        var TYPING_LIMIT = 1000; 
        
        var timer;
        var typingLimit = (attrs.hasOwnProperty('typingLimit')) ? parseInt(attrs.typingLimit, 10) : TYPING_LIMIT;

        // get the validation attributes which are the list of validators  
        var validationAttr = JSON.parse(attrs.validation2);

        // define the variables we'll use 
        var regexMessage;    
        var regexPattern;
        var validations;       
        var validators = [];

        // by default we'll consider field not required if not required then no need to validate empty value..right
        // if validation attribute calls it then we'll validate
        var isFieldRequired = false; 
                
        // We first need to see if the validation holds a regex, if it does treat it first
        // So why treat it separately? Because a Regex might hold pipe '|' and so we don't want to mix it with our regular validation pipe
        // Return string will have the complete regex pattern removed but we will keep ':regex' so that we can still loop over it
        if(validationAttr.indexOf("regex:") >= 0) {
          var matches = validationAttr.match("regex:(.*?):regex");
          var regAttrs = matches[1].split(':=');
          regexMessage = regAttrs[0];    
          regexPattern = regAttrs[1];

          // rewrite the validationAttr so that it doesn't contain the regex: ... :regex ending  
          // we simply remove it so that it won't break if there's a pipe | inside the actual regex
          validationAttr = validationAttr.replace(matches[0], 'regex:');
        } 

        // at this point it's safe to split with pipe (since regex was previously stripped out)
        validations = validationAttr;

        if(validations) {
          var minDate="",maxDate="";
          for(var i = 0, ln = validations.length; i < ln; i++) { 
        	 validations[i].message = intl_msg[validations[i]?.messageLabelId] ?? validations[i].message;
            switch(validations[i].type) {
              case "alpha" :
                validators[i] = {
                  pattern: "^([a-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$",
                  message:validations[i],
                  type: "regex"
                };
                break;
              case "alphaSpaces" :  
              case "alpha_spaces" :   
                validators[i] = {
                  pattern: "^([a-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\\s])+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_ALPHA_SPACE",
                  type: "regex"
                };
                break;
              case "alphaNum" :  
              case "alpha_num" :
                validators[i] = {
                  pattern: "^([a-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ])+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_ALPHA_NUM",
                  type: "regex"
                };
                break;
              case "alphaNumSpaces" :
              case "alpha_num_spaces" :
                validators[i] = {
                  pattern: "^([a-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\\s])+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_ALPHA_NUM_SPACE",
                  type: "regex"
                };
                break;
              case "alphaDash" :
              case "alpha_dash" :
                validators[i] = {
                  pattern: "^([a-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ_-])+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_ALPHA_DASH",
                  type: "regex"
                };
                break;
              case "alphaDashSpaces" :
              case "alpha_dash_spaces" :
                validators[i] = {
                  pattern: "^([a-z0-9ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïðòóôõöùúûüýÿ\\s_-])+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_ALPHA_DASH_SPACE",
                  type: "regex"
                };
                break;
              case constants.length.name :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                var a = (angular.isDefined(validations[i].properties[constants.length.minLen]))?validations[i].properties[constants.length.minLen]:0;
                var b = (angular.isDefined(validations[i].properties[constants.length.maxLen]))?validations[i].properties[constants.length.maxLen]:"";
                validators[i] = {
                  params: [a,b],
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_BETWEEN_CHAR",
                  pattern: "^.{" + a + "," + b + "}$",
                  type: "regex"
                };        
                break;
              case constants.numericRange.name :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                var floor = (angular.isDefined(validations[i].properties[constants.numericRange.minNum]))?validations[i].properties[constants.numericRange.minNum]:null;
                var ciel = (angular.isDefined(validations[i].properties[constants.numericRange.maxNum]))?validations[i].properties[constants.numericRange.maxNum]:null;
                if(floor == null){
                  validators[i] = {
                    condition: "<=",
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_BETWEEN_NUM",
                    params: [ciel],
                    type: "condition_num"
                  };  
                } else if(ciel == null){
                  validators[i] = {
                    condition: ">=",
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_BETWEEN_NUM",
                    params: [floor],
                    type: "condition_num"
                  }; 
                }else{
                  validators[i] = {
                    condition: [">=","<="],
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_BETWEEN_NUM",
                    params: [floor, ciel],
                    type: "condition_num"
                  };
                }
                break;
              case "dynamicMaxValue" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                var maxAttribute = (angular.isDefined(validations[i].properties["runTimeMax"]))?validations[i].properties["runTimeMax"]:null;
                if(maxAttribute === null){
                  break;
                }
                validators[i] = {
                  originalMessage: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_VALUE",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_VALUE",
                  params: [maxAttribute],
                  type: "dynamicMaxValue"
                };
                  break;
                case "dynamicMinMax":
                    if(!angular.isDefined(validations[i].properties)){
                        break;
                    }
                    validators[i] = {
                        message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_VALUE",
                        params: [validations[i].properties.upperBound,validations[i].properties.lowerBound],
                        type:"dynamicMinMax"
                    };
                    break;
              case "creditCard" :
              case "credit_card" :
                validators[i] = {
                  pattern: "^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\\d{3})\\d{11})$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_CREDIT_CARD",
                  type: "regex"
                };
                break;
              case "dateIso" :
              case "date_iso" :
                validators[i] = {
                  pattern: "^(19|20)\\d\\d([-])(0[1-9]|1[012])\\2(0[1-9]|[12][0-9]|3[01])$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_DATE_ISO",
                  type: "regex"
                };
                break;  
              case "dateUsLong" :
              case "date_us_long" :
                validators[i] = {
                  pattern: "^(0[1-9]|1[012])[-/](0[1-9]|[12][0-9]|3[01])[-/](19|20)\\d\\d$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_DATE_US_LONG",
                  type: "regex"
                };
                break;
              case "dateUsShort" :
              case "date_us_short" :
                validators[i] = {
                  pattern: "^(0[1-9]|1[012])[-/](0[1-9]|[12][0-9]|3[01])[-/]\\d\\d$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_DATE_US_SHORT",
                  type: "regex"
                };
                break;  
              case "dateEuroLong" :
              case "date_euro_long" :
                validators[i] = {
                  pattern: "^(0[1-9]|[12][0-9]|3[01])[-/](0[1-9]|1[012])[-/](19|20)\\d\\d$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_DATE_EURO_LONG",
                  type: "regex"
                };
                break;  
              case "dateEuroShort" :
              case "date_euro_short" :
                validators[i] = {
                  pattern: "^(0[1-9]|[12][0-9]|3[01])[-/](0[1-9]|1[012])[-/]\\d\\d$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_DATE_EURO_SHORT",
                  type: "regex"
                };
                break;  
              case "email" :
                validators[i] = {
                  pattern: "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_EMAIL",
                  type: "regex"
                };
                break;
              case "exactLen" :
              case "exact_len" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  pattern: "^.{" + validations[i].properties.length + "}$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_EXACT_LEN",
                  params: [validations[i].properties.length],
                  type: "regex"                  
                };
                break; 
              case "float" :
                validators[i] = {
                  pattern: "^\\d+[\\.]+\\d+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_FLOAT",
                  type: "regex"
                };
                bindFieldToBlockChars(true, false);
                break;
              case "floatSigned" :
              case "float_signed" :
                validators[i] = {
                  pattern: "^[-]?\\d+[\\.]+\\d+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_FLOAT_SIGNED",
                  type: "regex"
                };
                bindFieldToBlockChars(true, true);
                break;
              case "iban" :
                validators[i] = {
                  pattern: "[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_IBAN",
                  type: "regex" 
                };
                break; 
              case "integer" :
                validators[i] = {
                  pattern: "^\\d*$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_INTEGER",
                  type: "regex"
                };
                bindFieldToBlockChars(false, false);
                break;
              case "integerSigned" :
              case "integer_signed" :
                validators[i] = {
                  pattern: "^[-]?\\d+$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_INTEGER_SIGNED",
                  type: "regex"
                };
                bindFieldToBlockChars(false, true);
                break; 
              case "ipv4" :
                validators[i] = {
                  pattern: "^(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)(\\.(25[0-5]|2[0-4]\\d|[0-1]?\\d?\\d)){3}$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_IPV4",
                  type: "regex"
                };
                break; 
              case "ipv6" :
                validators[i] = {
                  pattern: "^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_IPV6",
                  type: "regex"
                };
                break; 
              case "ipv6_hex" :
                validators[i] = {
                  pattern: "^((?:[0-9A-Fa-f]{1,4}(?::[0-9A-Fa-f]{1,4})*)?)::((?:[0-9A-Fa-f]{1,4}(?::[0-9A-Fa-f]{1,4})*)?)$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_IPV6_HEX",
                  type: "regex"
                };
                break; 
              case "json" :
            	  validators [i] = {
            		message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_JSON",
            		type: "json"  
              	 };
            	 break;
              case "maxLen" :
              case "max_len" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                pattern: "^(.|\n){0," + validations[i].properties.length + "}$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MAX_CHAR",
                  params: [validations[i].properties.length],
                  type: "regex"
                };
                break;
              case "max_num" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  condition: "<=",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MAX_NUM",
                  params: [validations[i].properties.number],
                  type: "condition_num"
                };
                break;
              case "minLen" :
              case "min_len" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  pattern: "^(.|\n){" + validations[i].properties.length + ",}$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MIN_CHAR",
                  params: [validations[i].properties.length],
                  type: "regex"
                };
                break;
              case "min_num" :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  condition: ">=",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MIN_NUM",
                  params: [validations[i].properties.number],
                  type: "condition_num"
                };
                break; 
              case constants.numeric.name :
                validators[i] = {
                  pattern: "^\\d+[\\.]?\\d*$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_NUMERIC",
                  type: "regex"
                };
                bindFieldToBlockChars(true, false);
                break; 
              case "numeric_signed" :
            	elm.attr("type","text");
                validators[i] = {
                  pattern: "^[-]?\\d+[\\.]?\\d*$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_NUMERIC_SIGNED",
                  type: "regex"
                };
                bindFieldToBlockChars(true, true, true);
                break;
              case "regex" :
                // Regex is a special case, the regexMessage & regexPattern variables
                // were created and dealt separately prior to the for loop
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                regexPattern = validations[i].properties.pattern;
                regexMessage = validations[i].message;
                validators[i] = {
                  pattern: regexPattern,
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PATTERN",
                  params: [regexMessage],
                  type: "regex"
                };
                break;
              case constants.stakeHolder_selectFromOptions.name:
                isFieldRequired = true;
                if(angular.isUndefined(validations[i].model) || angular.isUndefined(validations[i].fieldType)){
                  break;
                }
                validators[i] = {
                  pattern: "\\S+",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"STAKEHOLDER_REQUIRED",
                  params: [validations[i].model, validations[i].fieldType],
                  type: "stakeHolder_selectFromOptions"
                };
                break;
              case constants.stakeHolder_required.name :
                isFieldRequired = true;
                if(angular.isUndefined(validations[i].model)){
                  break;
                }
                validators[i] = {
                  pattern: "\\S+",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"STAKEHOLDER_REQUIRED",
                  params: [validations[i].model],
                  type: "stakeHolder_required"
                };
                elm.attr("isMandatory", "true");
                break;
              case constants.required.name :
                isFieldRequired = true;
                validators[i] = {
                  pattern: "\\S+",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_REQUIRED",
                  type: constants.required.name
                };
                elm.attr("isMandatory", "true");
                break;
              case "url" :
                validators[i] = {
                  pattern: "(http|ftp|https):\\/\\/[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&amp;:/~\\+#]*[\\w\\-\\@?^=%&amp;/~\\+#])?",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_URL",
                  type: "regex"
                };
                break;
              case "time" :
                validators[i] = {
                  pattern: "^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_TIME",
                  type: "regex"
                };
                break;
              case constants.futureDate.name :
            	var options = scope.getDateOptions(ctrl,elm.attr("timewidget"));
                var today = scope.getCurrentDate();
              var m = moment.tz(today,SirionUtils.getDBDateFormat(), "UTC");
            	var newDate = m.tz("UTC");
                options.minDate = newDate._d;
                validators[i] = {
                  params : today,
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_FUTURE_DATE",
                  type: "futureDate"
                };
                	scope.$watch("data.timeZone.values",function(newVal,oldVal){
                    	if(newVal && newVal.timeZone){
                    		var timeZone = newVal.timeZone;
                        	m = moment.tz(scope.globalData.currentTime,SirionUtils.getDBDateTimeFormat(), "UTC");
                                var minDate = m.tz(timeZone)._d;
                                if(oldVal && oldVal.timeZone && m.tz(timeZone).format(SirionUtils.getDBDateFormat()) != m.tz(oldVal.timeZone).format(SirionUtils.getDBDateFormat())){
                                	if(!$rootScope.dateAlert){
                                        SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6491], heading: intl_msg[24153],yesName: 'OK',yesCbFn: 'cancel'});
                                    	$rootScope.dateAlert = true;
                                	}
                                }
                                // var minDF = $.datepicker.formatDate(scope.formatDate, new Date(options.minDate));
                               // elm.datetimepicker("option", 'minDate', minDate); /* commented for UI2.0 because of new calendar implementation */
                    	}
                		
                    })
                if(angular.isObject(today)){
                  minDate = today;
                }else{
                  var todayArr = today.split("-");
                  minDate = new Date(parseInt(todayArr[2]), parseInt(todayArr[0])-1, parseInt(todayArr[1]));
                }
                break;
              case constants.pastDate.name :
                var today = scope.getCurrentDate();
                validators[i] = {
                  params : today,
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                  type: "pastDate"
                };
                var options = scope.getDateOptions(ctrl,elm.attr("timewidget"));
                var m = moment.tz(today,SirionUtils.getDBDateFormat(), "UTC");
            	var newDate = m.tz("UTC");
                options.maxDate = newDate._d;
                	scope.$watch("data.timeZone.values",function(newVal,oldVal){
                    	if(newVal && newVal.timeZone){
                    		var timeZone = newVal.timeZone;
                        	m = moment.tz(scope.globalData.currentTime,SirionUtils.getDBDateTimeFormat(), "UTC");
//                        	m.endOf("day");
                        	options.maxDate = m.tz(timeZone)._d;
                            if(oldVal && oldVal.timeZone && m.tz(timeZone).format(SirionUtils.getDBDateFormat()) != m.tz(oldVal.timeZone).format(SirionUtils.getDBDateFormat())){
                            	if(!$rootScope.dateAlert){
                                    SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6491], heading: intl_msg[24153],yesName: 'OK',yesCbFn: 'cancel'});
                                	$rootScope.dateAlert = true;
                            	}
                            }                                
                            // var maxDF = $.datepicker.formatDate(scope.formatDate, new Date(options.maxDate));
                          /*if(!elm.attr("timewidget"))
                            elm.datetimepicker("option", 'maxDateTime', options.maxDate);*/ /* commented for UI2.0 because of new calendar implementation */
                        }
                    })
                if(angular.isObject(today)){
                  maxDate = today;
                }else{
                  var todayArr = today.split("-");
                  maxDate = new Date(parseInt(todayArr[2]), parseInt(todayArr[0])-1, parseInt(todayArr[1]));
                }
                break;
              case "pastLastActionDate" :
                var refDate = scope.getGlobalDataValue("lastActionDate");
                if(refDate!==null){
                  validators[i] = {
                    params : refDate,
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                    type: "pastDate",
                    includeToday : true
                  };
                  var refDateArr = refDate.split("-");
                  maxDate = new Date(parseInt(refDateArr[2]), parseInt(refDateArr[0])-1, parseInt(refDateArr[1]));
                }
                break;
              case "futureLastActionDate" :
                var refDate = scope.getGlobalDataValue("lastActionDate");
                if(refDate !== null){
                  validators[i] = {
                    params : refDate,
                      message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                      type: "futureDate",
                      includeToday: true
                  };
                  var refDateArr = refDate.split("-");
                  minDate = new Date(parseInt(refDateArr[2]), parseInt(refDateArr[0])-1, parseInt(refDateArr[1]));
                  }
                break;
              case constants.compareDate.name :
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  condition : validations[i].properties.condition,
                  compareWith : validations[i].properties.compareWith,
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                  type: "compareDate"
                };
                break;
              case "metaDataCreatedValidation":
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  params : validations[i].properties["varToCheck"],
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                  type: "metaDataCreatedValidation"
                };
                break;
              case "rateCardFromDate":
                var dataSource = validations[i].properties["dataSource"];
                var startDate = validations[i].properties["startDate"];
                var endDate = validations[i].properties["endDate"];
                dataSource = scope.getGFieldModel('', dataSource, "", "data");
                dataSource = showPageService.getModelfromString.call(scope,dataSource + ".values");
                var lastEl = scope.getDateObject(dataSource[0][endDate]);
                lastEl.setDate(lastEl.getDate() + 1);
                maxDate = lastEl;
                validators[i] = {
                  params : lastEl,
                  lastDate: scope.getDateObject(dataSource[0][endDate]),
                  startDate: scope.getDateObject(dataSource[0][startDate]),
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                  type: "rateCardFromDate"
                };
                break;
              case "rateCardEndDate":
                var dataSource = validations[i].properties["dataSource"];
                var startDate = validations[i].properties["startDate"];
                var endDate = validations[i].properties["endDate"];
                dataSource = scope.getGFieldModel('', dataSource, "", "data");
                dataSource = showPageService.getModelfromString.call(scope,dataSource + ".values");
                var firstEl = scope.getDateObject(dataSource[dataSource.length-1][startDate]);
                firstEl.setDate(firstEl.getDate() - 1);
                minDate = firstEl;
                validators[i] = {
                  startDate : firstEl,
                  endDate : lastEl,
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_PAST_DATE",
                  type: "rateCardEndDate"
                };
                break;
              case "decimalLength":
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  pattern: "^\\s*-?(\\d+(\\.\\d{1,"+validations[i].properties.length+"})?|\\.\\d{1,"+ validations[i].properties.length +"})\\s*$",
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MIN_CHAR",
                  params: [validations[i].properties.length],
                  type: "regex"
                };
                break;
              case "integerLength":
                  if(!angular.isDefined(validations[i].properties)){
                    break;
                  }
                  validators[i] = {
                    pattern: "^[\\-]?[\\d]{0," + validations[i].properties.length + "}(\\.[\\d]+){0,1}$",
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MIN_CHAR",
                    params: [validations[i].properties.length],
                    type: "regex"
                  };
                  bindFieldToBlockChars(true, false);
                  break;
              case "numericLength":
                  if(!angular.isDefined(validations[i].properties)){
                    break;
                  }
                  validators[i] = {
                    pattern: "^[-]{0,1}[\\d]{0," + validations[i].properties.length + "}(\\.[\\d]+){0,1}$",
                    message: (angular.isDefined(validations[i].message))?validations[i].message:"INVALID_MIN_CHAR",
                    params: [validations[i].properties.length],
                    type: "regex"
                  };
                  bindFieldToBlockChars(true, true);
                  break;
              case "noSpecial":
                /******syntax
                {
                        "message": "special characters not allowed",
                        "properties": {
                          "charMap": {"<":"&lt;",
                                      ">":"&gt;",
                                      "javascript":"java script"
                                      }
                        },
                        "type": "noSpecial"
                      }
                */
                if(!angular.isDefined(validations[i].properties)){
                  break;
                }
                validators[i] = {
                  message: (angular.isDefined(validations[i].message))?validations[i].message:"SPECIAL_CHAR_NOT_ALLOWED",
                  params: [validations[i].properties.charMap],
                  type: "noSpecial"
                };
                break;
            } // end of switch() 
          } // end of for()    
          if(minDate!=="" || maxDate!==""){
            var options = scope.getDateOptions(ctrl,elm.attr("timewidget"));
            if(maxDate!==""){
              options.maxDate = maxDate;
            }
            if(minDate!==""){
              options.minDate = minDate;
            }
            //elm.datetimepicker(options); /* commented for UI2.0 because of new calendar implementation */
          }     
        } // end of if()
        
        /** We seem to have little problems validating a field of <input type="number"> 
          * as angular reports undefined value even though user could type invalid chars
          * Bind trigger to block alpha chars completely except these: numbers, decimal and dash
          */
        var bindBlockingCharsOnInputNumber = function() {
            if(!angular.isDefined(elm.prop('type'))){
                return;
            }
            // get some properties of the inspected element
            var elmTagName = elm.prop('tagName').toUpperCase();
            var elmType = elm.prop('type').toUpperCase();

            // block chars completely, except numbers, decimal and dash
            if(elmTagName === "INPUT" && elmType === "NUMBER") {
                elm.bind('keydown', function(evt) {
                    var charCode = (evt.which) ? evt.which : ((typeof event !== "undefined") ? event.keyCode : undefined);
                    if(typeof charCode === "undefined") {
                        evt.preventDefault();
                        return false;
                    }

                    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    if(([65,67,86,88].indexOf(charCode) > -1 && evt.ctrlKey === true)){
                        return true;
                    }

                    if (charCode > 31 && (charCode != 46 && ((charCode < 48 || charCode > 57) && charCode < 96 || charCode > 105)) && (charCode != 189 && charCode != 190 && charCode != 110 && charCode != 109 && charCode != 173)) {
                        evt.preventDefault();
                        return false;
                    }
                });
            }
        }

        /** Cancel current validation test and blank any leftover error message */
        var cancelValidation = function() {
          //$timeout.cancel(timer);
          updateErrorMsg("");
          ctrl.$setValidity('validation', true);             
          elm.unbind('blur'); // unbind onBlur else it will fail if input became dirty & empty
        }

        /**
         * this function will compare two dates in string format of mm/dd/yyyy
         * prevDate: the date which is supposed to be in past
         * futureDate: the date which is supposed to be in future
         * allowEqualDate: whether or not to allow equal dates to return true
         */
        var compareDate = function(prevDate, futureDate, allowEqualDates) {
          if(typeof prevDate !== "string" || typeof futureDate !== "string"){
            return false;
          }
          futureDate = (futureDate.indexOf("/")>-1)?futureDate.split("/"):futureDate.split("-");
          prevDate = (prevDate.indexOf("/")>-1)?prevDate.split("/"):prevDate.split("-");
          
          var tmp = futureDate[1];
          futureDate[1] = futureDate[0];
          futureDate[0] = tmp;
          
          tmp = prevDate[1];
          prevDate[1] = prevDate[0];
          prevDate[0] = tmp;
          for(var i=2;i>=0;i--){
            futureDate[i] = parseInt(futureDate[i]);
            prevDate[i] = parseInt(prevDate[i]);
            if(futureDate[i]==prevDate[i]){
              continue;
            }
            return futureDate[i]>prevDate[i];
          }
          return allowEqualDates && true;//send true if it is todays date and allowEqualDates is true
        }
        
        /**
         * this function will validate if input type json contains valid json or not.
         * array, null and integer are handled not to be json.
        */
        var validateJSON = function(strValue) {
          try {
    	    var jsonValue = JSON.parse(strValue);
    	    if(angular.isArray(jsonValue) || jQuery.isEmptyObject(jsonValue)) {
    		    return false;
    	    } else {
    		    return true;
    	    }
          }	
          catch (err) {
        	  return false;
          }
        }

        /** Test values with condition, I have created a switch case for all possible conditions.
         * @var String condition: condition to filter with
         * @var any value1: 1st value to compare, the type could be anything (number, String or even Date)
         * @var any value2: 2nd value to compare, the type could be anything (number, String or even Date)
         * @return boolean: a boolean result of the tested condition (true/false)
         */
        var testCondition = function(condition, value1, value2) {
            var resultCond = false;
      
            switch (condition) {
                case '<': resultCond = (value1 < value2) ? true : false;
                    break;
                case '<=': resultCond = (value1 <= value2) ? true : false;
                    break;
                case '>': resultCond = (value1 > value2) ? true : false;
                    break;
                case '>=': resultCond = (value1 >= value2) ? true : false;
                    break;
                case '!=':
                case '<>': resultCond = (value1 != value2) ? true : false;
                    break;
                case '=':
                case '==': resultCond = (value1 == value2) ? true : false;
                    break;
            }
            return resultCond;
        }

        /** in general we will display error message at the next element after our input
          * but in some cases user want to define which DOM id to display error (as validation attribute)
          * @param bool isFieldValid: is the field valid?
          * @param string message: error message to display
          */
        var updateErrorMsg = function(message, isFieldValid, requiredValidationFailed) {
          var hasValidation = (typeof isFieldValid === "undefined") ? false : true;
          var parentErrorElm = (attrs.hasOwnProperty('validationErrorTo'))
            ? angular.element(document.querySelector('#'+attrs.validationErrorTo))
            : elm.next("[errorSpan]");
          
          if(parentErrorElm.length === 0){
            parentErrorElm = elm.parent().find("[errorSpan]");
          }
          
          if(parentErrorElm.length === 0){
            parentErrorElm = elm.parent().next("[errorSpan]");
          }
          
            var errorElm = parentErrorElm.find("[errorMessageHolder]");

          // Re-Render Error display element inside the <span> or <div>;
          if(angular.isDefined(isFieldValid)){
            if(elm.attr("name") == "documentFileData"){
            	if(elm.siblings("span").size()>0){
            		showPageService.setValidity.call(scope,elm.attr("name"), true);
            	} else{
            		showPageService.setValidity.call(scope,elm.attr("name"), false);
            	}
            }else{
            	showPageService.setValidity.call(scope,elm.attr("name"), isFieldValid);
            }
          }
          if(typeof errorElm !== "undefined") {
            //resetting field
              const fieldName = elm.attr("fieldname");
            if(_.has(scope.data, fieldName ) && scope.data[fieldName].options && scope.data[fieldName].options.enableListView && elm.closest(".autcompletePopGlobal.errorClass").length){
              elm.closest(".autcompletePopGlobal").removeClass("errorClass");
            }else if(_.has(scope.data, 'dynamicMetadata' ) && Object.keys(scope.data.dynamicMetadata).length){
              var tempData = _.extend(scope.data, scope.data.dynamicMetaData)
              if(_.has(tempData['dynamicMetadata'][fieldName], 'options.enableListView') && tempData['dynamicMetadata'][fieldName].options.enableListView){
                elm.closest(".autcompletePopGlobal").removeClass("errorClass");
              }
            }
              if(isFieldValid || !hasValidation){
                const totalErrorElem = angular.element(".dynamic-form").find(".errorClass:visible");
                elm.removeClass("errorClass");
                scope.changeErrorCount && scope.changeErrorCount(totalErrorElem, elm);
                errorElm.html("");
                parentErrorElm.addClass("hidden");
              }
            if(hasValidation && !isFieldValid && (ctrl.$dirty || scope.shouldIShowFieldErrors())) {
              // Not valid & dirty, display the message
              //var messageElm = getMessageElement(message);
              //errorElm.text(message);
              elm.addClass("errorClass");
              scope.changeErrorCount && scope.changeErrorCount(scope);
              //elm.css("border-color", "#ff0000 #0000ff");
              errorElm.html("");
              errorElm.append(message);
              if(!requiredValidationFailed){
                parentErrorElm.removeClass("hidden");
                  parentErrorElm.addClass("clientSideValidation");
                  if( elm.is("textarea") ){
                      parentErrorElm.addClass("text-area");
                  }
                if($("li.two-col-mesh") && $("li.two-col-mesh").hasClass("active") ){
                    parentErrorElm.addClass("two-col-mesh-active");
                    var offset = 2;
                    if(elm.height() != 0){
                        parentErrorElm.css("top", (elm.height() + offset) + "px");
                    }
                }
                else{
                    parentErrorElm.addClass("one-col-mesh-active");
                    var offset = 22;
                    // if(elm.height() != 0){
                        parentErrorElm.css("top", (elm.height() + offset) + "px");
                    // }
                }
              }
            }
          }
        }

        /** Validate function, from the input value it will go through all validators (separated by pipe)
         *  that were passed to the input element and will validate it. If field is invalid it will update
         *  the error text of the span/div element dedicated for that error display.
         * @param string value: value of the input field
         */
        var scientificToDecimal = function(num) {
            //if the number is in scientific notation remove it
            if(/\d+\.?\d*e[\+\-]*\d+/i.test(num)) {
                var zero = '0',
                    parts = String(num).toLowerCase().split('e'), //split into coeff and exponent
                    e = parts.pop(),//store the exponential part
                    l = Math.abs(e), //get the number of zeros
                    sign = e/l,
                    coeff_array = parts[0].split('.');
                if(sign === -1) {
                    coeff_array[0] = Math.abs(coeff_array[0]);
                    num = '-'+zero + '.' + new Array(l).join(zero) + coeff_array.join('');
                }
                else {
                    var dec = coeff_array[1];
                    if(dec) l = l - dec.length;
                    num = coeff_array.join('') + new Array(l+1).join(zero);
                }
            }

            return num;
        };
        var validate = function(strValue, onBlur,elementFieldType) {
          var isValid = true;
          var isFieldValid = true;
          var message = angular.element("<ul></ul>");
          var regex;          
          var requiredValidationFailed = false;

          var isEmpty = !scope.isDefinedAndNotNull(strValue) || ( angular.isObject(strValue) && $.isEmptyObject(strValue) );
          // loop through all validations (could be multiple)
          for(var j = 0, jln = validators.length; j < jln; j++) {
        	  if(validators[j] == undefined){
        		  continue;
        	  }
            if(validators[j].type === "condition_num") {
              if(!isEmpty){ 
                // a condition type
                if(validators[j].params.length == 2) {
                  // typically a "between" condition, a range of number >= and <= 
                  var isValid1 = testCondition(validators[j].condition[0], parseFloat(strValue), parseFloat(validators[j].params[0]));
                  var isValid2 = testCondition(validators[j].condition[1], parseFloat(strValue), parseFloat(validators[j].params[1]));
                  isValid = (isValid1 && isValid2) ? true : false;
                }else {
                  isValid = testCondition(validators[j].condition, parseFloat(strValue), parseFloat(validators[j].params[0]));
                }
              }
            }else if(validators[j].type === "noSpecial"){
              if(!isEmpty && elm.attr('name') !== 'name'){
                for(var charMap in validators[j].params[0]){
                  if(strValue.indexOf(charMap) > -1){
                    isValid = false;
                    break;
                  }
                }
              }
            }else if(validators[j].type === "dynamicMaxValue") { 
              if(!isEmpty && !elm.hasClass("hidden")){
                var attrToLookFor = validators[j].params[0];
                var attrValue = elm.attr(attrToLookFor);
                if(attrValue === "" || (elm.val() != "" && !elm.attr("checkMax"))){
                  isValid = false;
                  validators[j].message = "Select a document first";
                }else if(attrValue === "UNINDEXED"){
                  isValid = true;
                  validators[j].message = "Document is yet to be indexed. Please try attaching this document after sometime.";
                }else{
                  isValid = testCondition("<=", parseFloat(strValue), parseFloat(attrValue));
                  validators[j].message = validators[j].originalMessage;
                }
              }
            }else if(validators[j].type === "dynamicMinMax") {
                if(!isEmpty){
                    var reverse = false;
                    var msg1 = "";
                    var msg2 = "";
                    var threeLevel = false;
                    var checkValid = true;
                    var level1NoValidation = false;
                    var denyEquality = true;
                    validators[j].message = "";
                    if(scope.data.threshold && scope.data.threshold.values){
                        if(scope.data.threshold.values.id == 1 || scope.data.threshold.values.id == 3 || scope.data.threshold.values.id == 7){
                            reverse = true;
                        }
                        if(scope.data.threshold.values.id == 4 || scope.data.threshold.values.id == 3){
                            threeLevel = true;
                        }
                        if(scope.data.threshold.values.id == 5 || scope.data.threshold.values.id == 6){
                            level1NoValidation = true;
                        }
                        if(scope.data.threshold.values.id == 1 || scope.data.threshold.values.id == 2){
                            denyEquality = false;
                        }
                        function isALessThanB(a,b,denyEquality){
                            if(denyEquality){
                                return a <= b;
                            } else{
                                return a < b;
                            }
                        }
                        try {
                            if(!level1NoValidation) {
                                if (validators[j].params[0]) {
                                    msg1 = intl_msg[validators[j].params[0].messageLabelId];
                                    if (validators[j].params[0].checkThreshold && !threeLevel) {
                                        checkValid = false;
                                    }
                                    if (checkValid) {
                                        if (reverse && isALessThanB(Number(elm.val()), Number(scope.data[validators[j].params[0].field].values), denyEquality)) {
                                            isValid = false;

                                            msg1 = msg1.replace("%s", getLabelForName(elm.attr("name")));
                                            msg1 = msg1.replace("%s", getLabelForName(validators[j].params[0].field));
                                            validators[j].message += msg1;
                                        } else if (!reverse && isALessThanB(Number(scope.data[validators[j].params[0].field].values), Number(elm.val()), denyEquality)) {
                                            isValid = false;

                                            msg1 = msg1.replace("%s", getLabelForName(validators[j].params[0].field));
                                            msg1 = msg1.replace("%s", getLabelForName(elm.attr("name")));
                                            validators[j].message += msg1;

                                        }

                                    }
                                }
                                if (validators[j].params[1]) {
                                    checkValid = true;
                                    if (validators[j].params[1].checkThreshold && !threeLevel) {
                                        checkValid = false;
                                    }
                                    msg2 = intl_msg[validators[j].params[1].messageLabelId];
                                    if (checkValid) {
                                        if (!reverse && isALessThanB(Number(elm.val()), Number(scope.data[validators[j].params[1].field].values), denyEquality)) {
                                            isValid = false;
                                            msg2 = msg2.replace("%s", getLabelForName(validators[j].params[1].field));
                                            msg2 = msg2.replace("%s", getLabelForName(elm.attr("name")));
                                            validators[j].message += msg2;
                                        } else if (reverse && isALessThanB(Number(scope.data[validators[j].params[1].field].values), Number(elm.val()), denyEquality)) {
                                            isValid = false;
                                            msg2 = msg2.replace("%s", getLabelForName(elm.attr("name")));
                                            msg2 = msg2.replace("%s", getLabelForName(validators[j].params[1].field));
                                            validators[j].message += msg2;
                                        }
                                    }
                                }
                            }
                        } catch (e){
                            console.log(e);
                        }
                    }
                }
            }else if(validators[j].type === "metaDataCreatedValidation"){
              if(!isEmpty){
                var varToCheck = validators[j].params;
                if(angular.isDefined(strValue) && strValue!=null && angular.isDefined(varToCheck) && varToCheck!==null && angular.isObject(strValue)){
                  isValid = strValue[varToCheck];
                }else{
                  isValid = true;
                }
              }
            }else if(validators[j].type === "stakeHolder_selectFromOptions") {
              var mdl = validators[j].params[0];
              var dta = showPageService.getModelfromString.call(scope,mdl);
              var isSingleSelect = validators[j].params[1] === "single";
              if(dta === null){
                isValid = false;
              }else{
            	  isValid=true;
                if(isSingleSelect){
                  if(!angular.isObject(dta["values"][0])){
                    isValid = false;
                    dta["values"]=[];
                  }
                }else{
                  isValid = true;
                }
              }
            }else if(validators[j].type === "stakeHolder_required") {
              var mdl = validators[j].params[0];
              var dta = showPageService.getModelfromString.call(scope,mdl);
              if(dta === null || angular.isUndefined(dta.values)){
                isValid = false;
              }else{
                if(angular.isArray(dta.values)){
                  if(dta.values.length===0 || dta.values[0] === ""){
                    isValid = false;
                  }else{
                    isValid = true;
                  }
                }else{
                  isValid = (dta.values==null);
                }
              }
            } else if(validators[j].type === "futureDate") {
              if(!isEmpty){
                var includeToday = true;
                if(angular.isDefined(validators[j].includeToday)){
                  includeToday = validators[j].includeToday;
                }
                isValid = compareDate(validators[j].params, strValue, includeToday);
              }
            } else if(validators[j].type === "pastDate") {
              if(!isEmpty){
                var includeToday = true;
                if(angular.isDefined(validators[j].includeToday)){
                  includeToday = validators[j].includeToday;
                }
                isValid = compareDate(strValue, validators[j].params, includeToday);
              }
            } else if(validators[j].type === "compareDate") {
              if(!isEmpty){
                var compareModel = showPageService.getGFieldModel('', validators[j].compareWith, "", "data");
                var tempModel = showPageService.getModelfromString.call(scope,compareModel);
                if(tempModel === null || angular.isUndefined(tempModel.values) || tempModel.values === ""){
                  isValid = true;
                }else{
                  if(!angular.isDefined(tempModel) || tempModel == null){
                    isValid = false;
                  }else{
                    var condition = (validators[j].condition)?validators[j].condition.toLowerCase():"gt";
                    var allowEqualDates = (condition.charAt(condition.length - 1) === 'e') ? true : false;
                    var prevDate = tempModel.values;
                    var futureDate = strValue;
                    if(condition.charAt(0)=="l"){
                      prevDate = strValue;
                      futureDate = tempModel.values;
                    }
                    isValid = compareDate(prevDate, futureDate, allowEqualDates);
                  }
                }
              }
            }else if(validators[j].type === "json") {
            	isValid = validateJSON(strValue);
            } else {
              // a 'disabled' element should always be valid, there is no need to validate it
              if(elm.prop('disabled')) {
                isValid = true;
              } else {
                // run the Regex test through each iteration
                regex = new RegExp(validators[j].pattern, 'i');
                isValid = false;
                if(!(validators[j].pattern === "required" && typeof strValue === "undefined")){
                  if(angular.isDefined(strValue) && strValue !== null ){
                    if(("" + NaN)!==strValue){
                        if(elementFieldType && elementFieldType == "number")
                            strValue = scientificToDecimal(strValue);
                      isValid = regex.test(strValue);
                    }
                    
                    if( angular.isObject(strValue) && $.isEmptyObject(strValue) ) {
                    	isValid = false;
                    }
                    
                  }else{
                    if(strValue === null){
                      isValid = false;
                    } else{
                      isValid = regex.test("");
                    }
                  }
                }
                //isValid = (validators[j].pattern === "required" && typeof strValue === "undefined") ? true : regex.test(strValue);
              }
            }
            if(!isValid) {
              if([constants.required.name, "stakeHolder_required"].indexOf(validators[j].type) > -1){
                if(elm.attr("type") === "checkbox"){
                  continue;
                }
                requiredValidationFailed = true;
              }
              isFieldValid = false;

              var alignText = "center";
              if($(elm).closest(".linkedTable").length > 0){
                  alignText = "left";
              }
              message.append(angular.element("<li style = 'text-align:"+alignText+"'>" + $translate(validators[j].message) + "</li>"));

              // replace any error message params that were passed
              /*if(typeof validators[j].params !== "undefined") {
                for(var k = 0, kln = validators[j].params.length; k < kln; k++) {
                  message = message.replace((':param'), validators[j].params[k]);
                }
\              }*/
            } // end !isValid
          } // end for() loop

          // -- Error Display --//
          if(typeof event == "undefined" || typeof event != "undefined" && $(event.currentTarget).hasClass("addUser") == false){
              updateErrorMsg(message, isFieldValid, requiredValidationFailed);
          }

          return isFieldValid;
        }

        /** Validator function to attach to the element, this will get call whenever the input field is updated
         *  and is also customizable through the (typing-limit) for which inactivity timer will trigger validation.
         * @param string value: value of the input field
         */
        var validator = function(value) { 
          // if field is not required and his value is empty, cancel validation and exit out
          if(!isFieldRequired && (value === "" || typeof value === "undefined" || value === null)) {
            cancelValidation();
            return value;
          }

          // attach/bind trigger on a <input type="number"/> and only allow: numbers, decimal and dash
          bindBlockingCharsOnInputNumber();

          // invalidate field before doing any validation 
          ctrl.$setValidity('validation', false); 

          // onBlur make validation without waiting
          scope.textAreaBlur  = function(){
              scope.$apply(ctrl.$setValidity('validation', validate(ctrl.$modelValue, true) ));
         }
          
          elm.bind('blur', function() {
              var applyValidation = true;
              if(!scope.clauseSelectionService.checkCandidateForValition.call(scope,this)){
                  applyValidation = false;
              }
        	  // make the regular validation of the field value
            //scope.$apply(ctrl.$setValidity('validation', validate(value, true) ));
              if(applyValidation){
                  var fieldType = $(this).attr("type")
                  ctrl.$setValidity('validation', validate(ctrl.$modelValue, true,fieldType) );
              }
              if(!scope.$$phase){
                  scope.$apply();
                  
              }
              return value;

          });

          // onKeyDown event is the default of Angular, no need to even bind it, it will fall under here anyway
          // in case the field is already pre-filled, we need to validate it without looking at the event binding
          if(typeof value !== "undefined" && !(value === ""  || value === null || (value  instanceof Array && value.length === 0))) {
            // Make the validation only after the user has stopped activity on a field
            // everytime a new character is typed, it will cancel/restart the timer & we<ll erase any error mmsg
            updateErrorMsg("");
            //$timeout.cancel(timer);            
            //timer = $timeout(function() {  
            //  ctrl.$setValidity('validation', validate(value));
            //}, typingLimit);
          }

          return value;        
        }; // end of validator()

        // attach the Validator object to the element
        ctrl.$parsers.unshift(validator);
        ctrl.$formatters.unshift(validator);

        // for the case of field that might be ng-disabled, we should skip validation
        // Observe the angular disabled attribute
        attrs.$observe("disabled",function(disabled) {
            if(disabled) {
                // Turn off validation when disabled
                ctrl.$setValidity('validation', true);
            } else {
                // Re-Validate the input when enabled
                ctrl.$setValidity('validation', validate(ctrl.$viewValue));
            }
        });

      } // end of link: function()
    }; // end of return;
    function appendClassForNumberTypeField(element){
        element.addClass("number_field");
    }
  }); // end of directive
